export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
  /** Where the quote comes from, shown as a pill (voice-of-customer cards). */
  source?: string
}

/**
 * VOICE OF CUSTOMER, NOT REVIEWS OF THIS PACK.
 * Real public comments about OTHER art therapy resources, taken from the DPS-18
 * product research (ficha, section VOC). Keep them labeled as such.
 * Replace with real buyer reviews of this pack (with permission) once they exist.
 */
export const askedFor: Testimonial[] = [
  {
    quote:
      'I just wish it had included prepared reflective questions for each activity.',
    author: '3-star review',
    role: 'On an art therapy activities ebook',
    source: 'Teachers Pay Teachers',
  },
  {
    quote: 'Should have had some full session focused techniques.',
    author: 'Reader review, 2026',
    role: 'On a book of brief art therapy techniques',
    source: 'Goodreads',
  },
  {
    quote: 'A resource I can easily use without being an expert artist.',
    author: '5-star review',
    role: 'On an art therapy activities ebook',
    source: 'Teachers Pay Teachers',
  },
]

export const tiredOf: Testimonial[] = [
  {
    quote: 'Half of the book is generic coloring pages.',
    author: 'Review by an LMFT',
    role: 'On a CBT art activity book',
    source: 'Play Therapy Supply',
  },
  {
    quote: 'Mainly seemed weak and without any therapeutic purpose.',
    author: 'Reader review, 2025',
    role: 'On a book of brief art therapy techniques',
    source: 'Goodreads',
  },
  {
    quote: "I was hoping it would have ideas that I hadn't seen.",
    author: 'Buyer review',
    role: 'On an art therapy activities ebook',
    source: 'Teachers Pay Teachers',
  },
]
